import { render } from "./signup-name.vue?vue&type=template&id=33bb945c&scoped=true"
import script from "./signup-name.vue?vue&type=script&lang=js"
export * from "./signup-name.vue?vue&type=script&lang=js"

import "./signup-name.vue?vue&type=style&index=0&id=33bb945c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bb945c"]])

export default __exports__